import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import ActionStatus from './action-status';
import ActionStatusDetail from './action-status-detail';
import ActionStatusUpdate from './action-status-update';
import ActionStatusDeleteDialog from './action-status-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={ActionStatusUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={ActionStatusUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={ActionStatusDetail} />
      <ErrorBoundaryRoute path={match.url} component={ActionStatus} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={ActionStatusDeleteDialog} />
  </>
);

export default Routes;
